
























import { Component, Prop, Vue } from 'vue-property-decorator'
import { BProgress, BProgressBar, BBadge } from 'bootstrap-vue'

@Component({
  components: { BProgress, BProgressBar, BBadge },
  name: 'etp-gauge'
})
export default class EtpGauge extends Vue {
  @Prop({ required: true, type: Number, default: 0 }) actuel!: number
  @Prop({ required: true, type: Number, default: 0 }) cible!: number
  @Prop({ required: true, type: String, default: 'ETP' }) label!: string
  @Prop({ required: false, type: Number, default: 0.05 }) tolerance!: number

  get progressMax(): number {
    return Math.max(this.cible, this.actuel, 1)
  }

  get statut(): 'sur' | 'sous' | 'ok' {
    if (this.actuel > this.cible + this.tolerance) return 'sur'
    if (this.actuel < this.cible - this.tolerance) return 'sous'
    return 'ok'
  }

  get statutLabel(): string {
    if (this.statut === 'sur') return 'Sur-staffé'
    if (this.statut === 'sous') return 'Sous-staffé'
    return 'OK'
  }

  get badgeVariant(): string {
    if (this.statut === 'sur') return 'light-warning'
    if (this.statut === 'sous') return 'light-danger'
    return 'light-success'
  }

  get barVariant(): string {
    if (this.statut === 'sur') return 'warning'
    if (this.statut === 'sous') return 'danger'
    return 'success'
  }

  formatEtp(value: number | undefined | null): string {
    if (value == null || isNaN(value)) return '—'
    return Number(value).toFixed(2)
  }
}
